import { useState } from "react";

// Logo Energy Market : utilise /img/logo-energy-market.png si présent,
// sinon repli automatique sur un monogramme « E ».
export default function Logo({ dark = false, className = "h-10" }) {
  const [err, setErr] = useState(false);
  return (
    <span className="flex items-center gap-2.5">
      {!err ? (
        <img
          src={dark ? "/img/logo-energy-market-blanc.png" : "/img/logo-energy-market.png"}
          alt="Energy Market"
          className={`w-auto shrink-0 transition-all duration-500 ${className}`}
          onError={() => setErr(true)}
        />
      ) : (
        <>
          <span className={`inline-flex h-9 w-9 items-center justify-center rounded-xl font-display font-black ${dark ? "bg-accent text-accent-foreground" : "bg-primary text-primary-foreground"}`}>
            E
          </span>
          <span className="font-display text-lg font-bold tracking-tight">Energy Market</span>
        </>
      )}
    </span>
  );
}
